/* =========================================================================
   WCAG 2.2 SC 2.2.2 / 4.1.2 motion controls — WS2 (case 514658-2026)
   getbreathdeath.com remediation.

   Drives the keyboard-accessible pause/resume controls added to the three
   marquees (marquee-custom, x-marquee, secondary-sub-marquee) and the cover
   video (custom-video-block). Vanilla JS, no jQuery dependency.

   - Marquees: toggle .is-paused + an inline !important animation-play-state on
     the section's .track; flip aria-pressed; swap the visible label.
   - Cover video: toggle the muted autoplay video's play state; flip
     aria-pressed; swap aria-label ("Pause video" <-> "Play video").
   - On load, if the user prefers reduced motion, every marquee and the cover
     video start paused, with the control reflecting the paused/"Resume" state.

   Idempotent: each control is wired once via a data flag so re-running (or a
   double include) does not double-bind handlers.
   ========================================================================= */
(function () {
  'use strict';

  var prefersReduced = false;
  try {
    prefersReduced =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {}

  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  function closest(el, selector) {
    if (el && el.closest) {
      return el.closest(selector);
    }
    return null;
  }

  ready(function () {
    /* --- Marquee pause/resume controls (WS2.1 / F-2.2.2-a) -------------- */
    var marqueeBtns = document.querySelectorAll('[data-wcag-pause]');
    Array.prototype.forEach.call(marqueeBtns, function (btn) {
      if (btn.getAttribute('data-wcag-bound') === 'true') {
        return;
      }
      btn.setAttribute('data-wcag-bound', 'true');

      var parent = closest(btn, '.marquee-parent');
      var track = parent ? parent.querySelector('.track') : null;
      var label = btn.querySelector('.wcag-marquee-pause__label');

      function setPaused(paused) {
        if (track) {
          track.classList.toggle('is-paused', paused);
          /* Inline !important is the authoritative runtime control: it beats
             both the section's own !important running rule and the
             reduced-motion media query, so a reduced-motion user can resume. */
          track.style.setProperty(
            'animation-play-state',
            paused ? 'paused' : 'running',
            'important'
          );
        }
        btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        if (label) {
          label.textContent = paused
            ? 'Resume scrolling text'
            : 'Pause scrolling text';
        }
      }

      /* Honour the reduced-motion default on load. */
      setPaused(prefersReduced);

      btn.addEventListener('click', function () {
        var nowPaused = btn.getAttribute('aria-pressed') !== 'true';
        setPaused(nowPaused);
      });
    });

    /* --- Cover-video pause/resume controls (WS2.2, WS2.4 /
           F-2.2.2-b, F-4.1.2-e) --------------------------------------- */
    var videoBtns = document.querySelectorAll('[data-wcag-video-pause]');
    Array.prototype.forEach.call(videoBtns, function (btn) {
      if (btn.getAttribute('data-wcag-bound') === 'true') {
        return;
      }
      btn.setAttribute('data-wcag-bound', 'true');

      var parent = closest(btn, '.custom-video-block-parent');
      var video = parent ? parent.querySelector('.video-cover-custom') : null;
      var vLabel = btn.querySelector('.wcag-video-pause__label');

      function reflect(paused) {
        btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        /* Accessible name comes from the visible label; keep both in sync so
           there is no Label-in-Name (SC 2.5.3) mismatch. */
        if (vLabel) {
          vLabel.textContent = paused ? 'Play video' : 'Pause video';
        } else {
          btn.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
        }
      }

      /* Reduced motion: do not let the muted autoplay run by default. */
      if (prefersReduced && video) {
        try {
          video.pause();
        } catch (e) {}
      }
      reflect(video ? video.paused : prefersReduced);

      btn.addEventListener('click', function () {
        if (!video) {
          return;
        }
        if (video.paused) {
          var p = video.play();
          if (p && p.catch) {
            p.catch(function () {});
          }
          reflect(false);
        } else {
          video.pause();
          reflect(true);
        }
      });

      /* Keep the control in sync if playback state changes elsewhere. */
      if (video) {
        video.addEventListener('play', function () {
          reflect(false);
        });
        video.addEventListener('pause', function () {
          reflect(true);
        });
      }
    });
  });
})();
